import { FC } from 'react'

import { useTitle } from 'hooks/useTitle'
import { CategoryMarketGrowthDashboard } from 'modules/categoryMarketGrowth/components'

const CategoryMarketGrowthPage: FC = () => {
  useTitle('menu.categoryMarketGrowth')

  return <CategoryMarketGrowthDashboard />
}

export default CategoryMarketGrowthPage
